export type DashboardWidgetId =
    | 'aiReport'
    | 'totalInventory'
    | 'offlineInventory'
    | 'inventoryStatus'
    | 'efficiency'
    | 'activeMaintenance'
    | 'notInMotion'
    | 'efficiencyRanking'
    | 'criticalNotifications';

export const DASHBOARD_WIDGET_IDS: DashboardWidgetId[] = [
    'aiReport',
    'totalInventory',
    'offlineInventory',
    'inventoryStatus',
    'efficiency',
    'activeMaintenance',
    'notInMotion',
    'efficiencyRanking',
    'criticalNotifications'
];

export const DASHBOARD_GRID_COLUMNS = 12;
export const DASHBOARD_GRID_MAX_Y = 500;
export const DASHBOARD_GRID_MAX_H = 40;
export const DASHBOARD_GRID_ROW_HEIGHT = 40;
export const DASHBOARD_GRID_MARGIN = 16;

export interface DashboardWidgetLayout {
    id: DashboardWidgetId;
    visible: boolean;
    x: number;
    y: number;
    w: number;
    h: number;
}

export interface DashboardLayout {
    version: number;
    widgets: DashboardWidgetLayout[];
}

export interface DashboardWidgetMinSize {
    minW: number;
    minH: number;
}

export const DASHBOARD_WIDGET_MIN_SIZE: Record<DashboardWidgetId, DashboardWidgetMinSize> = {
    aiReport: { minW: 6, minH: 6 },
    totalInventory: { minW: 2, minH: 2 },
    offlineInventory: { minW: 2, minH: 2 },
    inventoryStatus: { minW: 3, minH: 4 },
    efficiency: { minW: 3, minH: 4 },
    activeMaintenance: { minW: 3, minH: 4 },
    notInMotion: { minW: 3, minH: 4 },
    efficiencyRanking: { minW: 3, minH: 4 },
    criticalNotifications: { minW: 3, minH: 4 }
};
